import { render, staticRenderFns } from "./new3.vue?vue&type=template&id=31163e44&"
import script from "./new3.vue?vue&type=script&lang=js&"
export * from "./new3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports